// @ts-ignore
import { Deferred } from 'simply-deferred'

const debug = {
    dev: false
}

// DEPRECATED!!!   Use async-session-loader.ts

const SessionLoader = function () {

    let transport = 'ajax';
    // let deferredLoader = new $.Deferred(); // create new deferred object
    let deferredLoader = new Deferred(); // create new deferred object

    deferredLoader.process = function(dataToLoad) {

        if (debug.dev) console.log("sessionLoader.process", dataToLoad);

        // Do nothin if there is nothing to load
        if (!dataToLoad || _.isEmpty(dataToLoad) ) {
            if (debug.dev) console.log("sessionLoader.process -> NO data -> resolve()");
            this.resolve();
            return;
        }


        if (debug.dev) {
            console.groupCollapsed("@Session lazy loading...",_.size(dataToLoad));
            console.log(dataToLoad);
            console.groupEnd();
        }

        const findMissingData = (data)=>{
            const { taskTypes, projects } = data;
            if (!taskTypes && !projects) return false;

            let allCustomFields = [];
            taskTypes && taskTypes.map((ttId)=>{
                const taskType = gd.session.taskTypes.get(ttId);
                if (taskType) allCustomFields = _.union(allCustomFields, taskType.customFields);
            });

            projects && projects.map((pId)=>{
                const project = gd.session.projects.get(pId);
                if (project) allCustomFields = _.union(allCustomFields, project.customFields);
            });

            return gd.session.findMissing({
                customFields: allCustomFields
            });
        };

        const sessionDataLoader = gd.api.Session.getMissingData(dataToLoad); // new ApiCall(this,'POST','session',dataToLoad);

        sessionDataLoader.done((response)=>{

            //load custom fields data for just loaded taskTypes
            const cfDataToLoad = findMissingData(dataToLoad);
            if (cfDataToLoad) {
                let cfLoader = gd.api.Session.getMissingData(cfDataToLoad); // new ApiCall(this,'POST','session',cfDataToLoad);
                cfLoader.done((response)=>{ this.resolve(); });
                cfLoader.fail((error)=>{ gd.apiError(error); this.reject(); });
            } else {
                this.resolve();
            }
        });

        sessionDataLoader.fail((error)=>{ gd.apiError(error); this.reject(); });

    }

    return deferredLoader
}

module.exports = SessionLoader